// import PropTypes from 'prop-types'
import { Grid } from '@mui/material'
import React from 'react'

import CheckableFormItem from '../CheckableFormItem'
import FormItem from '../FormItem'

interface ElementProps {
  name: string
  key?: string
  value?: any
  label?: string
  query?: any
  queryOptions?: object
  disabled?: boolean
  sm?: number
  md?: number
  lg?: number
  xl?: number
  xs?: number
  sx?: {}
}
interface Props {
  checkable?: boolean
  elements: ElementProps[]
  sx?: {}
}

const InputGroup: React.FC<Props> = React.memo(({ checkable = false, elements, sx = {} }) => (
  <Grid container sx={sx} spacing={2}>
    {checkable ? (
      <>
        {
          // @ts-ignore
          elements.map(({ sm, md, lg, xl, xs, key, ...elementProps }) => (
            <Grid key={key || elementProps.name} size={{ xs: xs || 12, sm, md, lg, xl }}>
              <CheckableFormItem {...elementProps} />
            </Grid>
          ))
        }
      </>
    ) : (
      <>
        {
          // @ts-ignore
          elements.map(({ sm, md, lg, xl, xs, key, ...elementProps }) => (
            <Grid
              sx={elementProps.sx}
              key={key || elementProps.name}
              size={{ xs: xs || 12, sm, md, lg, xl }}
            >
              {/* @ts-ignore */}
              <FormItem {...elementProps} />
            </Grid>
          ))
        }
      </>
    )}
  </Grid>
))

InputGroup.displayName = 'InputGroup'

export default InputGroup
